import { API_INTERNAL_ENDPOINT } from './constants'
import type {
  AuthUser,
  AuthUserTypeKeys,
  ParametersOwner,
  ParametersTraveler,
} from '~~/modules/auth/entities/AuthUser'
import { type schemaType } from './schema'

export type returnType = ApiServerResponse<schemaType>

export default async (): Promise<AuthUser<any>> => {
  try {
    const runtimeConfig = useRuntimeConfig()
    const requestFetch = useRequestFetch()

    const url = `${runtimeConfig.public.NUXT_API_CONTENT_ROOT_URL}/${API_INTERNAL_ENDPOINT}`

    const data = (await requestFetch(url, {
      method: 'POST',
      key: url,
    })) as returnType

    if (data.success && data.success.data) {
      const parsedData = data.success.data

      const user: AuthUser<any> = {
        logged: parsedData.logged,
      }

      if (parsedData.userData) {
        const { fullName, emailAddress, picture, id, userType } =
          parsedData.userData

        if (picture) user.avatar = picture
        if (fullName) user.name = fullName
        if (emailAddress) user.mail = emailAddress
        if (id) user.id = id

        if (userType) {
          user.type = userType.toLowerCase() as AuthUserTypeKeys

          if (userType === 'OWNER' && parsedData.ownerMenuOptions) {
            user.params = {
              has_webpage:
                parsedData.ownerMenuOptions.websiteOptionType || false,
              unread_messages: parsedData.ownerMenuOptions.unreadMessages || 0,
              unread_bookings: parsedData.ownerMenuOptions.unreadBookings || 0,
            } as ParametersOwner
          } else if (
            userType === 'TRAVELER' &&
            parsedData.travelerMenuOptions
          ) {
            user.params = {
              has_booking: parsedData.travelerMenuOptions.hasBookings || false,
              unread_messages:
                parsedData.travelerMenuOptions.unreadMessages || 0,
              cottage_bookmarks:
                parsedData.travelerMenuOptions.cottageBookmarks,
            } as ParametersTraveler
          }
        }
      }

      return user
    } else {
      const user: AuthUser<any> = {
        logged: false,
      }
      console.error('Error de User IsLogged')
      return user
    }
  } catch {
    const user: AuthUser<any> = {
      logged: false,
    }
    console.error('Error de User IsLogged')
    return user
  }
}
